module.exports = __webpack_public_path__ + "img/img3.e31a3aa7.png";